import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateProgramme, type ProgrammeDto } from "../api/programmesApi";
import { queryKeys } from "../lib/queryKeys";

export function useUpdateProgramme(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (dto: ProgrammeDto) => updateProgramme(id, dto),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.programmes.all });
      qc.invalidateQueries({ queryKey: queryKeys.programmes.detail(id) });
    },
  });
}
